import React, { useState } from 'react';
import { supabase, isSupabaseConfigured } from '../supabaseClient';

function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message] = useState('');
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);

  if (!isSupabaseConfigured()) {
    return (
      <div className="auth-wrapper">
        <div className="auth-card auth-config-warning">
          <div className="auth-logo">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="24" fill="#0C447C"/>
              <path d="M14 24 C14 18 18 14 24 14 C30 14 34 18 34 24 C34 30 30 34 24 34 C18 34 14 30 14 24Z" stroke="white" strokeWidth="2.5" fill="none"/>
              <path d="M20 24 L23 27 L28 21" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <h1>En Cintura</h1>
          </div>
          <div className="config-warning">
            <h3>Configuración requerida</h3>
            <p>Para usar la app, configura tus credenciales de Supabase en el archivo <code>.env</code>:</p>
            <div className="code-block">
              <code>REACT_APP_SUPABASE_URL=tu_url_aqui</code>
              <code>REACT_APP_SUPABASE_ANON_KEY=tu_clave_aqui</code>
            </div>
            <p>
              Crea tu proyecto gratis en{' '}
              <strong>supabase.com</strong> y ejecuta el archivo{' '}
              <code>supabase-schema.sql</code> en el SQL Editor.
            </p>
            <p>Luego reinicia el servidor de desarrollo.</p>
          </div>
        </div>
      </div>
    );
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message === 'Invalid login credentials'
      ? 'Correo o contraseña incorrectos.' : error.message);
    setLoading(false);
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(forgotEmail, {
      redirectTo: window.location.origin,
    });
    if (error) {
      setError(error.message);
    } else {
      setForgotSent(true);
    }
    setLoading(false);
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div className="auth-logo">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#0C447C"/>
            <path d="M16 28 Q18 16 24 14 Q30 16 32 28" stroke="white" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
            <circle cx="24" cy="30" r="3" fill="white"/>
            <path d="M18 34 L30 34" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
          <h1>En Cintura</h1>
          <p>Que viva el llano Apureño</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        {!showForgot ? (
          <>
            <form onSubmit={handleLogin} className="auth-form">
              <div className="form-group">
                <label>Correo electrónico</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  required
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label>Contraseña</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? 'Ingresando...' : 'Ingresar'}
              </button>
            </form>
            <button
              className="auth-forgot-btn"
              onClick={() => { setShowForgot(true); setError(''); setForgotSent(false); }}
            >
              ¿Olvidaste tu contraseña?
            </button>
          </>
        ) : forgotSent ? (
          <div className="forgot-sent">
            <div className="forgot-sent-icon">📬</div>
            <h3>¡Correo enviado!</h3>
            <p>Revisa tu bandeja de entrada en <strong>{forgotEmail}</strong> y sigue el enlace para crear una nueva contraseña.</p>
            <button className="auth-btn" onClick={() => { setShowForgot(false); setForgotSent(false); setForgotEmail(''); }}>
              Volver al inicio de sesión
            </button>
          </div>
        ) : (
          <>
            <p className="forgot-title">Escribe tu correo y te enviamos un enlace para restablecer tu contraseña.</p>
            <form onSubmit={handleForgot} className="auth-form">
              <div className="form-group">
                <label>Tu correo electrónico</label>
                <input
                  type="email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  placeholder="tu@correo.com"
                  required
                  autoFocus
                />
              </div>
              <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
              </button>
            </form>
            <button className="auth-forgot-btn" onClick={() => { setShowForgot(false); setError(''); }}>
              ← Volver al inicio de sesión
            </button>
          </>
        )}

        <div className="auth-private-note">
          🔒 Esta app es privada — solo para las usuarias invitadas.
        </div>
      </div>
    </div>
  );
}

export default Auth;
